import React from 'react';
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  styled,
  CircularProgress,
  Box,
  Typography
} from '@mui/material';

import { useGetReportProg } from '../reports/Services';

interface ReportProgProps {
  idprogprop: string;
}

const HeadTableCell = styled(TableCell)({
  fontSize: '0.6rem',
  fontWeight: 'bold',
  textAlign: 'left',
});

const RowTableCell = styled(TableCell)({
  padding: '2px 4px',
  fontSize: '0.6rem',
  textAlign: 'center',
});

const ReportProg: React.FC<ReportProgProps> = ({ idprogprop }) => {

const codprog = idprogprop?.split("-")[1] ?? "";


const {
  data: { results = [], count } = {},
  isError: isLoadingReportProgError,
  isFetching: isFetchingReportProgVersore,
  isLoading: isLoadingReportProgVersore,
} = useGetReportProg(codprog);

  if (isLoadingReportProgVersore || isFetchingReportProgVersore) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={50} />
      </Box>
    );
  }

  if (isLoadingReportProgError) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="error">
          Error loading report
        </Typography>
      </Box>
    );
  }





  const filteredResults = results.filter(
    (row) => row.codnodo && row.codnodo.trim().length > 6
  );

  return (
    <TableContainer component={Paper}>

      {/* small spinner while refetching when project changes */}
      {isFetchingReportProgVersore && (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 1 }}>
          <CircularProgress size={18} />
        </Box>
      )}

      <Table size="small">

        <TableHead>
          <TableRow>
            <HeadTableCell>Nodo</HeadTableCell>
            <HeadTableCell>Ore</HeadTableCell>
            <HeadTableCell>Prep</HeadTableCell>
            <HeadTableCell>Prev</HeadTableCell>
            <HeadTableCell>Rest</HeadTableCell>
            <HeadTableCell>Diff</HeadTableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredResults.map((row, index) => (
            <TableRow key={index}>
              <RowTableCell sx={{ textAlign: 'left' }}>
                {row.desnodo}
              </RowTableCell>
              <RowTableCell>{row.ore}</RowTableCell>
              <RowTableCell>{row.oreprep}</RowTableCell>
              <RowTableCell>{row.oreprev}</RowTableCell>
              <RowTableCell>{row.orerest}</RowTableCell>
              <RowTableCell>{row.orediff}</RowTableCell>
            </TableRow>
          ))}
        </TableBody>

      </Table>

    </TableContainer>
  );
};

export default ReportProg;